import { Link } from "react-router-dom";
import { AlertOctagon, Clock, ArrowRight } from "lucide-react";
import { useTodaysChecklist } from "@/lib/tasks";

export default function UrgentTasksBanner() {
  const { urgentOpen, loading } = useTodaysChecklist();

  if (loading || urgentOpen.length === 0) return null;

  return (
    <Link
      to="/checklist"
      data-testid="urgent-tasks-banner"
      className="block rounded-2xl border-2 border-destructive/40 bg-destructive/5 p-5 sm:p-6 shadow-sm transition-all hover:-translate-y-[1px] hover:border-destructive/60"
    >
      <div className="flex items-start gap-4">
        <div className="size-10 rounded-xl bg-destructive text-destructive-foreground flex items-center justify-center shrink-0">
          <AlertOctagon strokeWidth={2} className="size-5" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] font-bold uppercase tracking-[0.12em] text-destructive">
            Highly urgent · needs attention
          </div>
          <h3
            className="font-display text-xl sm:text-2xl font-extrabold tracking-tight mt-0.5"
            data-testid="urgent-banner-headline"
          >
            {urgentOpen.length} urgent task{urgentOpen.length === 1 ? "" : "s"} for today
          </h3>
          <ul className="mt-3 space-y-1.5">
            {urgentOpen.slice(0, 4).map((t) => (
              <li
                key={t.id}
                className="flex items-center gap-2 text-sm"
                data-testid={`urgent-banner-task-${t.id}`}
              >
                <span className="size-1.5 rounded-full bg-destructive shrink-0" />
                <span className="font-semibold truncate">{t.title}</span>
                {t.time && (
                  <span className="inline-flex items-center gap-1 text-xs text-muted-foreground shrink-0">
                    <Clock strokeWidth={1.5} className="size-3" />
                    {t.time}
                  </span>
                )}
              </li>
            ))}
            {urgentOpen.length > 4 && (
              <li className="text-xs text-muted-foreground pl-3.5">
                +{urgentOpen.length - 4} more
              </li>
            )}
          </ul>
        </div>
        <ArrowRight strokeWidth={1.5} className="size-5 text-muted-foreground shrink-0 mt-1" />
      </div>
    </Link>
  );
}
